import React from 'react';
import { Facebook, ChevronRight, Users, Heart, MessageCircle, Share2, Bell, Globe } from 'lucide-react';

const FacebookSection: React.FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const facebookFeatures = [
        {
            number: "01",
            title: "Actualités en temps réel",
            description: "Suivez toutes nos annonces et événements en direct",
            icon: Bell,
            color: "text-primary-blue",
            bgColor: "bg-primary-blue/10"
        },
        {
            number: "02",
            title: "Communauté active",
            description: "Échangez avec des milliers de membres UDB",
            icon: Users,
            color: "text-primary-green",
            bgColor: "bg-primary-green/10"
        },
        {
            number: "03",
            title: "Contenu exclusif",
            description: "Accédez à des contenus et analyses approfondies",
            icon: Heart,
            color: "text-primary-yellow",
            bgColor: "bg-primary-yellow/10"
        },
        {
            number: "04",
            title: "Discussions ouvertes",
            description: "Participez aux débats sur l'avenir du Gabon",
            icon: MessageCircle,
            color: "text-primary-blue",
            bgColor: "bg-primary-blue/10"
        },
        {
            number: "05",
            title: "Partage d'expériences",
            description: "Témoignages et histoires de nos membres",
            icon: Share2,
            color: "text-primary-green",
            bgColor: "bg-primary-green/10"
        },
        {
            number: "06",
            title: "Réseau national",
            description: "Connectez-vous avec des Gabonais du monde entier",
            icon: Globe,
            color: "text-primary-yellow",
            bgColor: "bg-primary-yellow/10"
        }
    ];

    const handleFacebookClick = () => {
        window.open('https://facebook.com/udbgabon', '_blank', 'noopener,noreferrer');
    };

    return (
        <section id="facebook" className="overflow-hidden">

            <div className="bg-gray-900 text-white py-12">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <h3 className="text-2xl font-light mb-4">Restez connectés avec UDB</h3>
                        <div className="w-16 h-1 bg-primary-yellow mx-auto mb-6"></div>
                        <p className="text-lg font-light leading-relaxed mb-8 opacity-90 max-w-3xl mx-auto">
                            Ne manquez aucune actualité, participez aux discussions et faites partie
                            du mouvement qui transforme le Gabon.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            <button
                                onClick={handleFacebookClick}
                                className="bg-blue-600 text-white px-8 py-3 font-semibold hover:bg-blue-700 transition-colors inline-flex items-center space-x-2 group"
                            >
                                <Facebook className="w-4 h-4" />
                                <span>SUIVRE NOTRE PAGE</span>
                                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                            </button>

                            <button
                                onClick={() => window.open('https://facebook.com/udbgabon/posts', '_blank', 'noopener,noreferrer')}
                                className="bg-primary-green text-white px-8 py-3 font-semibold hover:bg-green-600 transition-colors inline-flex items-center space-x-2 group"
                            >
                                <span>VOIR NOS ACTUALITÉS</span>
                                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                            </button>
                        </div>

                        {/* Statistiques Facebook (optionnel) */}
                        <div className="mt-12 pt-8 border-t border-gray-700">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                                <div>
                                    <div className="text-2xl font-bold text-primary-yellow mb-1">@udbgabon</div>
                                    <div className="text-sm text-gray-400">Notre page officielle</div>
                                </div>
                                <div>
                                    <div className="text-2xl font-bold text-primary-yellow mb-1">Active</div>
                                    <div className="text-sm text-gray-400">Communauté engagée</div>
                                </div>
                                <div>
                                    <div className="text-2xl font-bold text-primary-yellow mb-1">24/7</div>
                                    <div className="text-sm text-gray-400">Actualités en continu</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FacebookSection;
